import styled from "styled-components";

export default styled.div`
  margin-left: auto;
  padding: 0 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-style: solid;
  border-color: #f2f4f6;
  border-width: 0 2px;
  font-size: 20px;
  color: #000c24;
  line-height: 1;
`;
